import { useIsUrlCrawlable } from 'hooks/useIsUrlCrawlable'
import { SourceType } from './Types'
import { Doc } from 'screens/BrandKits/components/BrandVoice/ContentSourcePicker/FromDoc'

const validationMessages: Record<string, string> = {
  'linktr.ee':
    "Blaze does not currently support this url.  You can use the 'Turn Videos into Content' option to add video content manually.",
  'youtube.com':
    "Blaze does not currently support this url.  You can use the 'Turn Videos into Content' option to add video content manually.",
}

export const useIsSourceValid = ({
  sourceType,
  contentUrl,
  file,
  document,
  pdf,
}: {
  sourceType: SourceType | null
  contentUrl?: string
  file?: File | null
  pdf?: File | null
  document?: Doc
}) => {
  const { isValid, errorMessage } = useIsUrlCrawlable(contentUrl || '', validationMessages)
  if (!sourceType) return { isValid: false, errorMessage: 'Please select a source type' }
  if (sourceType === SourceType.File) {
    return !!document || !!pdf
      ? { isValid: true, errorMessage: undefined }
      : { isValid: false, errorMessage: undefined }
  }
  if (sourceType === SourceType.Website) {
    return { isValid, errorMessage }
  }

  return { isValid: !!file, errorMessage: !file ? 'Please upload a file' : undefined }
}
